const locationAndCounts = {
    state: {
        addLocationAndCountsDialog: {
            title: '新增地点与人数信息',
            type: 'add'
        }
    },
    getters: {
        addLocationAndCountsDialog: state => state.addLocationAndCountsDialog,
    },
    mutations: {
        SET_LOCATION_AND_COUNTS_DIALOG_TITLE: (state, type) => {
            if (type === 'add') {
                state.addLocationAndCountsDialog.title = '新增新增地点与人数信息'
                state.addLocationAndCountsDialog.type = 'add'
            } else {
                state.addLocationAndCountsDialog.title = '编辑新增地点与人数信息'
                state.addLocationAndCountsDialog.type = 'edit'
            }
        }
    },
    actions: {

    }
}

export default locationAndCounts